ixModuleRouting("impactx.sapconfig", {
    "/sapconfiglist": {
        template: "<ixa-sap-config-list></ixa-sap-config-list>",
        process: "SAPConfiguration",
        workspace: "admin",
    },
    "/sapmatnrlist": {
        template: "<ixa-sap-materialnumber-list></ixa-sap-materialnumber-list>",
        templateUrl: "modules/sapconfig/templates/sapmatnr.html",
        process: "SAPConfiguration",
        controller: "SAPMaterialNumberListCtrl",
        controllerAs: "sapMaterialNumberListCtrl",
        workspace: "admin",
    },
    "/sapisocodselist": {
        template: "<ixa-sap-isocodes-list></ixa-sap-isocodes-list>",
        process: "SAPConfiguration",
        workspace: "admin",
    },
    "/sapconfig/:id": {
        template: "<ixa-sap-config-dialog></ixa-sap-config-dialog>",
        process: "SAPConfiguration",
        workspace: "admin",
    },
    "/sapekolist": {
        template: '<ixa-sap-eko-list></ixa-sap-eko-list>',
        templateUrl: "modules/sapconfig/templates/sapekolist.html",
        process: "SAPEKO",
        controller: "SAPEKOListController",
        controllerAs: "sapEKOListController",
        workspace: "admin",
    },
    "/sapekglist": {
        template: "<ixa-sap-ekg-list></ixa-sap-ekg-list>",
        templateUrl: "modules/sapconfig/templates/sapekglist.html",
        process: "SAPEKG",
        controller: "SAPEKGListController",
        controllerAs: "sapEKGListController",
        workspace: "admin",
    },
    "/sapeko/:id": {
        template: "<ixa-sap-eko-dialog></ixa-sap-eko-dialog>",
        templateUrl: "modules/sapconfig/templates/sapekodetail.html",
        process: "SAPEKO",
        controller: "SAPEKOEditController",
        controllerAs: "sapEKOEditController",
        workspace: "admin",
    },
    "/sapekg/:id": {
        template: "<ixa-sap-ekg-dialog></ixa-sap-ekg-dialog>",
        templateUrl: "modules/sapconfig/templates/sapekgdetail.html",
        process: "SAPEKG",
        controller: "SAPEKGEditController",
        controllerAs: "sapEKGEditController",
        workspace: "admin",
    },
    "/taxcode/:sapConfigId/:id": {
        template: "<ixa-sap-tax-code-dialog></ixa-sap-tax-code-dialog>",
        templateUrl: "modules/sapconfig/templates/taxcode.html",
        process: "SAPConfiguration",
        controller: "TaxCodeCtrl",
        controllerAs: "taxCodeCtrl",
        workspace: "admin",
    },
    "/sapcurrency/:sapConfigId": {
        template: '<ixa-sap-currency></ixa-sap-currency>',
        templateUrl: "modules/sapconfig/templates/currency.html",
        process: "SAPConfiguration",
        controller: "CurrencyCtrl",
        controllerAs: "currencyCtrl",
        workspace: "admin",
    },
    '/taxcodes/:sapConfigId': {
        template: "<ixa-sap-tax-codes-list></ixa-sap-tax-codes-list>",
        templateUrl: 'modules/sapconfig/templates/taxcodelist.html',
        process: 'SAPConfiguration',
        controller: 'TaxCodesListCtrl',
        controllerAs: 'taxCodesListCtrl',
        workspace: 'admin',
    },
    "/sapextension/:sapConfigId/:id?": {
        template: "<ixa-sap-extension-dialog></ixa-sap-extension-dialog>",
        process: "SAPConfiguration",
        workspace: "admin",
    }
});
